<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import learningApiUser from '@src/services/api/learning/user'
import { useLearningAuthStore } from '@stores/auth'
import { useLearningUserStore } from '@stores/user'

import Modal from '@components/modal/Modal.vue'

const { registerInfo } = storeToRefs(useLearningUserStore())
const { updateAccessToken } = useLearningAuthStore()
const router = useRouter()

const errorMessage = ref('')

const showCompleteModal = ref(false)
const accountFormItems = computed(() => {
  return [
    {
      label: 'メールアドレス',
      value: registerInfo.value.email
    },
    {
      label: '希望ログインID',
      value: registerInfo.value.identifier
    },
    {
      label: 'パスワード',
      value: '・・・・・・・・・・'
    },
    {
      label: '氏名/フリガナ',
      value: registerInfo.value.lastName + ' ' + registerInfo.value.firstName + ' / ' + registerInfo.value.lastNameKatakana + ' ' + registerInfo.value.firstNameKatakana
    },
    // {
    //   label: 'ニックネーム',
    //   value: registerInfo.value.nickname
    // },
    {
      label: '生年月日',
      value: registerInfo.value.year + '年' + registerInfo.value.month + '月' + registerInfo.value.date + '日'
    },
    {
      label: '性別',
      value: registerInfo.value.gender
    },
    {
      label: '自宅都道府県',
      value: registerInfo.value.pref
    },
    {
      label: '営業所会社名',
      value: registerInfo.value.office
    },
    {
      label: '営業所屋号',
      value: registerInfo.value.officeSection
    },
    {
      label: '会社住所',
      value: '〒' + registerInfo.value.officeZipcode + ' ' + registerInfo.value.officePref + ' ' + registerInfo.value.officeCity + ' ' + registerInfo.value.officeStreet + ' ' + registerInfo.value.officeBuilding
    },
    {
      label: '会社電話番号',
      value: registerInfo.value.officeTel
    },
    {
      label: '会社FAX番号',
      value: registerInfo.value.officeFax
    },
    {
      label: '販売責任者',
      value: registerInfo.value.officeManagerFlag ? 'はい' : 'いいえ'
    }
  ]
})

const toPincode = () => {
  showCompleteModal.value = false
  router.push({
    name: 'RegisterPincode'
  })
}

const sendAccountForm = () => {
  console.log('registerInfo', registerInfo.value)
  const body = {
    email: registerInfo.value.email,
    identifier: registerInfo.value.identifier,
    // name: registerInfo.value.nickname,
    password: registerInfo.value.password,
    displays: {
      name: [
        registerInfo.value.lastName,
        registerInfo.value.firstName
      ],
      spell: [
        registerInfo.value.lastNameKatakana,
        registerInfo.value.firstNameKatakana
      ],
      birthday: registerInfo.value.year + '-' + ('00' + Number(registerInfo.value.month)).slice(-2) + '-' + ('00' + Number(registerInfo.value.date)).slice(-2),
      gender: registerInfo.value.gender,
      address: {
        pref: registerInfo.value.pref
      },
      office: {
        name: registerInfo.value.office,
        section: registerInfo.value.officeSection ? registerInfo.value.officeSection : null,
        address: {
          zipcode: registerInfo.value.officeZipcode,
          pref: registerInfo.value.officePref,
          city: registerInfo.value.officeCity,
          street: registerInfo.value.officeStreet,
          building: registerInfo.value.officeBuilding ? registerInfo.value.officeBuilding : null
        },
        telephone: registerInfo.value.officeTel,
        facsimile: registerInfo.value.officeFax ? registerInfo.value.officeFax : null,
        manager: registerInfo.value.officeManagerFlag ? registerInfo.value.officeManagerFlag : false
      }
    }
  }
  console.log('body', body)
  learningApiUser.postUserSingup(body).then((res) => {
    console.log('postUserSingup res', res)
    // console.log('userInfo', userInfo)
    updateAccessToken(res.data.access_token)
    showCompleteModal.value = true
  }).catch((err) => {
    console.error('postUserSingup err', err)
    if (err.response.data.message === 'Conflict') {
      errorMessage.value = 'すでに使用されているログインIDです。'
    } else {
      errorMessage.value = 'エラーが発生しました。'
    }
  })
}

onMounted(() => {
  window.scrollTo(0, 0)

  console.log('onMounted', registerInfo.value)
  if (!registerInfo.value?.email) {
    router.push({
      name: 'RegisterInput'
    })
  }
})
</script>

<template>
  <section>
    <div class="container">
      <h2>新規受講登録（確認）</h2>
      <p>
        入力した内容を確認し、確認メールを送信ボタンを押してください。<br><br>
      </p>
      <div
        v-for="(item, index) in accountFormItems"
        :key="index"
        class="p-confirm-item"
      >
        <p class="p-confirm-item__label">
          {{ item.label }}
        </p>
        <p class="p-confirm-item__value">
          {{ item.value }}
        </p>
      </div>

      <!-- APIエラー表示 -->
      <div
        v-if="errorMessage"
        class="p-form-error">
        {{ errorMessage }}
      </div>

      <div class="btnContainer">
        <button
          type="submit"
          class="c-button c-button--medium c-button--yellow"
          @click="sendAccountForm"
        >
          確認メールを送信
        </button>
        <RouterLink
          :to="{name:'RegisterInput'}"
          class="c-button c-button--medium c-button--border"
        >
          戻る
        </RouterLink>
      </div>
    </div>

    <Modal :show="showCompleteModal">
      <template #body>
        <div class="l-modal__body">
          <h2 class="l-modal__ttl">
            確認メールを送信しました。
          </h2>
          <div class="l-modal__buttons">
            <button
              class="c-modalBtn c-modalBtn--single c-modalBtn--gray"
              type="button"
              @click="toPincode"
            >
              閉じる
            </button>
          </div>
        </div>
      </template>
    </Modal>
  </section>
</template>

<style scoped lang="scss">
.container {
  h2 {
    padding: 30px 0 15px;
    font-size: 26px;
    text-align: left;
    font-weight: bold;
  }
}
.btnContainer {
  margin-top: 20px;
}
</style>
